import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const contactSectionStyles = {
  imageWrapper: (theme: Theme): SystemStyleObject<Theme> => ({
    mx: "auto",
    maxWidth: 700,
    position: "relative",
    mb: { xs: -4, md: -6, lg: -6, xl: -7 },
    zIndex: -1,

    "&::after": {
      content: "''",
      position: "absolute",
      zIndex: 1,
      width: "100%",
      left: 0,
      height: "40%",
      pointerEvents: "none",
      bottom: 0,
      backgroundImage: `linear-gradient(0deg, ${theme.palette.background.default} 0%, ${theme.palette.background.default} 50%, transparent)`,
    },
  }),
};

export default contactSectionStyles;
